module.exports = __webpack_public_path__ + "static/media/iphone 12 banner5.7b26b34d.jpg";